import { i18n } from '@/i18n'
import store from '@/store'

export default (params) => {
  const role = store.getters['auth/role']
  const hasModuleAsignacionEmailReglas = store.getters['auth/hasModuleAsignacionEmailReglas']
  const hasModulePresentacionesAEAT = store.getters['auth/hasModulePresentacionesAEAT']
  const menu = [
    {
      icon: 'notification',
      name: i18n.t('app.notifications'),
      path: 'notifications',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'notification/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
      ]
    }
  ]
  const submenuGroups = {
    name: i18n.t('app.groups_link'),
    path: 'notification/groups',
    params,
    registerNavFromMenu: false,
    sc: [] // shorcuts
  }
  const submenuHistorical = {
    name: i18n.t('app.historical'),
    path: 'notification/historical',
    params,
    registerNavFromMenu: false,
    sc: [] // shorcuts
  }
  const submenuEmails = {
    name: i18n.t('app.emails_link'),
    path: 'notification/emails',
    params,
    registerNavFromMenu: false,
    sc: [] // shorcuts
  }
  const submenuPresentationsAEAT = {
    name: i18n.t('app.presentations_aeat'),
    path: 'notification/presentations',
    params,
    registerNavFromMenu: false,
    sc: [] // shorcuts
  }
  if (role === 'Administrador' || role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador') {
    menu[0].sc.push(submenuGroups)
  }
  if (hasModuleAsignacionEmailReglas && (role === 'Usuario' || role === 'Administrador' || role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')) {
    menu[0].sc.push(submenuEmails)
  }
  if (hasModulePresentacionesAEAT && (role === 'Usuario' || role === 'Administrador' || role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')) {
    menu[0].sc.push(submenuPresentationsAEAT)
  }
  menu[0].sc.push(submenuHistorical)

  return menu
}
